import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { checkoutSchema } from '../validation/checkoutSchema'
import { makeRequest } from '../apis/makeRequest'
import { getCustomerAddresses, getCustomer } from '../apis/backendRequests'
import CustomerAddress from '../components/CustomerAddress'
import { Grid, Typography, Divider, TextField } from '@mui/material'
import { useForm } from 'react-hook-form'

const fields = checkoutSchema.describe().fields
const addressFields = fields.customerAddresses.innerType.fields

export default function Perfil() {

    const { dynamicsId } = useSelector(state => state.account)

    const [customerAddresses, setCustomerAddresses] = useState([])
    const [customer, setCustomer] = useState({})

    const { control } = useForm()

    useEffect(() => {
        if (!dynamicsId)
            return

        makeRequest(
            () => getCustomer(dynamicsId),
            (res) => setCustomer(res.data), null, { checkEmptyResults: false }
        )
        makeRequest(
            () => getCustomerAddresses(dynamicsId),
            (res) => setCustomerAddresses(res.data), null, { checkEmptyResults: false }
        )
    }, [dynamicsId])

    function parseNumber(str) {
        if (typeof str !== "undefined") return str.replace(/[^0-9]/g, "");
        return "";
    }


    return (
        <>
            <Typography variant="h5" align="center" gutterBottom>Perfil</Typography>
            <Divider style={{ marginBottom: '1em' }} />
            <Grid container spacing={1}>
                <Grid item xs={12} md={6} >
                    <TextField sx={{ width: "100%" }} size='small' value={dynamicsId || ''} label='Código Cliente' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField sx={{ width: "100%" }} size='small' value={customer?.customerClassDescription || ''} label='DESCRIPCION DE CLIENTE' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField sx={{ width: "100%" }} size='small' value={customer?.taxRegistrationNumber?.replace(/\s/g, "") || ''} label='CUIT' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField sx={{ width: "100%" }} size='small' value={customer?.customerClassId || ''} label='Clase' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField sx={{ width: "100%" }} size='small' value={customer?.salesTerritory || ''} label='Zona de Venta' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField sx={{ width: "100%" }} size='small' value={customer?.address1 || ''} label='Direccion' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField sx={{ width: "100%" }} size='small' value={customer?.country || ''} label='pais' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField sx={{ width: "100%" }} size='small' value={customer?.city || ''} label='ciudad' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField sx={{ width: "100%" }} size='small' value={customer?.state || ''} label='provincia' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField sx={{ width: "100%" }} size='small' value={customer?.zip || ''} label='codigo postal' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField sx={{ width: "100%" }} size='small' value={parseNumber(customer?.phone1) || ''} label='telefono' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField sx={{ width: "100%" }} size='small' value={customer?.salesPersonId || ''} label='vendedor' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField sx={{ width: "100%" }} size='small' value={customer?.paymentTermId || ''} label='forma de pago ' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField sx={{ width: "100%" }} size='small' value={customer?.creditLimit || ''} label='limite de credito' />
                </Grid>

                {/* <Grid item xs={12} md={6} >
                    <TextField size='small' value={customer?.custblnc || ''} label='cuentas a cobrar' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField size='small' value={customer?.salestotal || ''} label='ventas sin contabilizar' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField size='small' value={customer?.returnstotal || '0'} label='devoluciones sin contabilizar' />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField size='small' value={customer?.credito || ''} label='saldo de credito' />
                </Grid> */}

                <Grid item xs={12}>
                    <Typography variant='h6' align="center" gutterBottom>Datos de facturación </Typography>
                    <Divider style={{ marginBottom: '1em' }} />
                </Grid>

                {Object.keys(customerAddresses).length !== 0 && <CustomerAddress
                    index={0}
                    schema={addressFields}
                    readOnly
                    customerAddress={customerAddresses?.find(c => c.addressCode === customer.billToAddress)}
                    control={control}
                />}
                <Grid item xs={12}>
                    <Typography variant='h6' align="center" gutterBottom> Direccion de entrega </Typography>
                    <Divider style={{ marginBottom: '1em' }} />
                </Grid>
                {Object.keys(customerAddresses).length !== 0 && <CustomerAddress
                    index={1}
                    schema={addressFields}
                    readOnly
                    customerAddress={customerAddresses?.find(c => c.addressCode === customer.sendToAddress)}
                    control={control}
                />}
            </Grid>
        </>
    )
}